import React, { PureComponent } from 'react';

import { BROWSER_IMAGES } from '../../shared/Constants';

export default class BrowserSupportWarning extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            closed: false
        };
    }

    closeComponent = () => {
        this.setState({ closed: true });
    };

    render() {
        const { closed } = this.state;
        if (closed) {
            return null;
        }
        return (
            <div className={'container-fluid browser-support-banner'}>
                <i onClick={this.closeComponent} className={'exit fa fa-times'} />
                <div className={'container'}>
                    <div className={'row'}>
                        <div className={'col-12'}>
                            <h4 className={'browser-support-banner-heading'}>
                                We're sorry, your current browser is not supported by Verb.
                            </h4>
                        </div>
                        <div className={'col-12 browser-support-banner-text'}>
                            Verb works best with Chrome or Firefox. For a better experience, we recommend downloading
                            and installing one of these browsers.
                        </div>
                        <div className={'col-12 browser-support-banner-buttons'}>
                            <div className={'row'}>
                                <div className={'col-12'}>
                                    <a href={'https://www.google.com/chrome/'}>
                                        <button className={'col-md-3 col-sm-6 col-12 verbStandardButton secondary'}>
                                            <img width={24} src={BROWSER_IMAGES.chrome} />
                                            GOOGLE CHROME
                                        </button>
                                    </a>
                                    <a href={'https://www.mozilla.org/en-US/firefox/'}>
                                        <button className={'col-md-3 col-sm-6 col-12 verbStandardButton secondary'}>
                                            <img width={24} src={BROWSER_IMAGES.firefox} />
                                            MOZILLA FIREFOX
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
